export default __webpack_public_path__ + "static/media/cat.855d1632.webp";